import { Pipe, PipeTransform } from '@angular/core';
import { DeviceProcessingModesWithSurface } from '../../../modules/devices/device.helper';

function convertMode(mode: string): string {
  if (!mode) {
    return '';
  }
  if (!DeviceProcessingModesWithSurface[mode]) {
    // eslint-disable-next-line no-console
    console.error('Cannot translate mode', mode);
  }
  return DeviceProcessingModesWithSurface[mode] || mode;
}

@Pipe({
  name: 'deviceProcModeWithSurface',
})
export class DeviceProcModeWithSurfacePipe implements PipeTransform {

  transform(mode: string): string {
    return convertMode(mode as string);
  }
}

@Pipe({
  name: 'deviceProcMODESWithSurface',
})
export class DeviceProcModesWithSurfacePipe implements PipeTransform {

  transform(modes: string[]): string[] {
    return modes?.map ? modes.map(m => convertMode(m)) : modes;
  }
}
